import { createTheme } from "@mui/material/styles";
declare module "@mui/material/styles" {
  interface Palette {
    header: Object;
    custom: Object;
  }
  interface PaletteOptions {
    header: Object;
    custom: Object;
  }
}
// Create a theme instance.
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#6E8C20",
    },
    secondary: {
      main: "#D84D4D",
    },
    common: {
      white: "#FFFFFF",
      black: "#000000",
    },
    header: {
      links: { main: "#323232" },
      background: { light: "#E1FFA2" },
    },
    custom: {
      background: {
        dark: {
          light: "#383838",
        },
      },
    
      
    },
  },
  typography: {
    fontFamily: ["Inter"].join(","),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disableRipple: true,
        disableFocusRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: ["Inter"].join(","),
          fontWeight: 400,
          paddingLeft: "1.5rem",
          paddingRight: "1.5rem",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: ["Inter"].join(","),
          fontWeight: 400,
          "& span": {
            fontSize: 14,
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: ["Inter"].join(","),
          color: "#383838",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        inputProps: {
          min: "0",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#d5e5b4",
          height: "4rem",
        },
      },
      defaultProps: {
        sx: {
          th: {
            fontWeight: 500,
            fontFamily: "CircularStd",
            fontSize: 16,
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          maxHeight: "610px",
          minHeight: "500px",
          overflow: "auto",
        },
      },
    },
  },
});

export default theme;
